export class NotificationReads
    {
        public NotificationId: string;
        public UserId: number;
        public Created: Date;
        public ReadUser: string;
        public UserName: string;
    }